import { useCallback, useEffect, useMemo, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Button } from "../../../ui/button";
import { Input } from "../../../ui/input";
import { Badge } from "../../../ui/badge";
import {
  Plus,
  Search,
  Users,
  Eye,
  Calendar,
  Wallet,
  Trash2,
  Edit,
  FileText,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
  // FileSpreadsheet,
  Filter,
  X,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
  Upload,
  DollarSign,
  Ban,
  ChevronUp,
  ChevronDown,
  UserRoundCheck,
  PencilRuler,
  EarthLock,
  BarChart3,
} from "lucide-react";
import { Label } from "../../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../ui/select";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../ui/dialog";
import { RadioGroup, RadioGroupItem } from "../../../ui/radio-group";
import { toast } from "sonner";
import ConfirmDialog from "../../../ui/ConfirmDialog";
import {
  getViseDashboardSummary,
  getAllDraftVisaList,
  getAllSubmittedList,
  getMoreRequestList,
  getisPendingRequestList,
  getCompletedRequestList,
  getMiqaatByTourOperator
} from "../../../services/visaService";
import { DraftVisaItem } from "../../../types/itsDetails";
import Pagination from "../../../ui/pagination";
import { FullScreenLoading } from "../../../components/ui/loader";
import { NoApplicantFound } from "../../../ui/noRecordfound";
import useDebounce from "../../../hooks/useDebounce";
import {
  CountryApi,
  getCountries,
} from "../../../services/visaFeeMasterService";
import { deleteDraftVisaApplication } from "../../../services/visaService";
import { getWalletSummary, getWalletSummaryByTO } from "../../../services/toLedgerWalletService";
import { useAuth } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useScreenPermission } from "../../../hooks/useScreenPermission";
import { usePageHeader } from "contexts/PageHeaderContext";



interface VisaApplicantManagementPageProps {
  onNavigate: (page: string) => void;
}

interface DashboardSummary {
  total: number;
  drafts: number;
  underReview: number;
  visaRequested: number;
  completed: number;
}

export interface MiqaatDetails {
  miqaatName: string;
  miqaatCode: string;
  rotationName: string;
  rotationId: string;
  arrivalDate: string;
  departureDate: string;
  availableQuota?: number;
  totalQuota?: number;
}

export const VisaApplicantManagementPage = ({
  onNavigate,
}: VisaApplicantManagementPageProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { setPageHeader } = usePageHeader();
  // const canAddApplicant = user?.permissions?.[18]?.add;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tourOperatorId = (user as any)?.tourOperatorId ?? null;
  const isTourOperator = !!tourOperatorId;
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [showStatistics, setShowStatistics] = useState(false);
  const [sortColumn, setSortColumn] = useState<string>("applicationNo");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [isDraftOpen, setIsDraftOpen] = useState(false);
  const [isSubmittedOpen, setIsSubmittedOpen] = useState(false);
  const [isReqMoreOpen, setIsReqMoreOpen] = useState(false);
  const [isPendingOpen, setIsPendingOpen] = useState(false);
  const [isCompletedOpen, setIsCompletedOpen] = useState(false);


  // ADVANCED SEARCH FILTER & PAGINATION STATE FIELDS
  const [searchTerm, setSearchTerm] = useState("");
  const [filterFields, setFilterFields] = useState({
    applicationNo: "",
    applicantName: "",
    itsNumber: "",
    passportNo: "",
    nationality: "",
    status: "",
    draftStatus: "",
    visaRequired: "",
    itsNo: "",

    pageNo: 1,
    submittedpageNo: 1,
    requestMorepageNo: 1,
    isPendingpageNo: 1,
    CompletedpageNo: 1,

    DraftpageSize: 5,
    SubmiitedpageSize: 5,
    RequestMorepageSize: 5,
    isPendingpageSize: 5,
    CompletedpageSize: 5
  });

  const mergedFilters = useMemo(
    () => ({
      ...filterFields,
      searchTerm,
    }),
    [filterFields, searchTerm],
  );


  const debouncedFilters = useDebounce(mergedFilters, 400);
  // ADVANCE FILTES & SEARCH TERM PAGINATION END

  // Delete confirmation dialog state
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [draftToDelete, setDraftToDelete] = useState<string | null>(null);

  // Tour type selection dialog state
  const [showTourTypeDialog, setShowTourTypeDialog] = useState(false);
  const [selectedTourOption, setSelectedTourOption] =
    useState<string>("general"); // 'general' or miqaat ID

  const [dashboardSummary, setDashboardSummary] = useState<DashboardSummary | null>(null);
  const [miqaatDetails, setMiqaatDetails] = useState<MiqaatDetails[]>([]);
  const [draftList, setDraftList] = useState<DraftVisaItem[]>([]);
  const [RequestMoreList, setRequestMoreList] = useState<DraftVisaItem[]>([]);
  const [isPendingList, setIsPendingList] = useState<DraftVisaItem[]>([]);
  const [CompletedList, setCompletedList] = useState<DraftVisaItem[]>([]);
  const [submittedApplicantsList, setsubmittedApplicantsList] = useState<
    DraftVisaItem[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [totalDraftCount, setTotalDraftCount] = useState(0);
  const [totalSubmittedListCount, setTotalSubmittedListCount] = useState(0);
  const [totalRequestListCount, setTotalRequestListCount] = useState(0);
  const [totalIsPendingListCount, setIsPendingListCount] = useState(0);
  const [totalCompletedListCount, setCompletedListCount] = useState(0);
  const [countries, setCountries] = useState<CountryApi[]>([]);

  const [walletBalance, setWalletBalance] = useState<number>(0);
  const [currencySymbol, setCurrencySymbol] = useState<string>("$");

  const { canAdd, canEdit, canDelete, screenName, icon: ScreenIcon } = useScreenPermission();
  // const [selectedDrafts, setSelectedDrafts] = useState<number[]>([]);
  const [selectedDrafts, setSelectedDrafts] = useState<DraftVisaItem[]>([]);




  // API CALLS START
  // LOAD NATIONALITY
  const loadCountries = useCallback(async () => {
    try {
      const res = await getCountries();
      setCountries(res.filter((c) => c.isActive));
    } catch {
      toast.error("Failed to load countries");
    }
  }, []);

  const fetchMiqaat = useCallback(async () => {
    if (!tourOperatorId) return;
    try {
      setLoading(true);
      const data = await getMiqaatByTourOperator(tourOperatorId);
      setMiqaatDetails(data)
    } catch {
      toast.error("Failed to fetch draft visa applications");
    } finally {
      setLoading(false);
    }
  }, [tourOperatorId]);

  const fetchDashboardVisaSummary = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getViseDashboardSummary();
      setDashboardSummary(data)
    } catch {
      toast.error("Failed to fetch draft visa applications");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchDraftVisaList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getAllDraftVisaList(debouncedFilters);
      setDraftList(data.items);
      setTotalDraftCount(data.totalCount);
    } catch {
      toast.error("Failed to fetch draft visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  const fetchSubmittedVisaList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getAllSubmittedList(debouncedFilters);
      setsubmittedApplicantsList(data.items);
      setTotalSubmittedListCount(data.totalCount);
    } catch {
      toast.error("Failed to fetch submitted visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  const fetchRequestMoreInfoVisaList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getMoreRequestList(debouncedFilters);
      setRequestMoreList(data.items);
      setTotalRequestListCount(data.totalCount);
    } catch {
      toast.error("Failed to fetch request more visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  const fetchIsPendingRequestList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getisPendingRequestList(debouncedFilters);
      setIsPendingList(data.items);
      setIsPendingListCount(data.totalCount);
    } catch {
      toast.error("Failed to fetch request more visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  const fetchCompeletedRequestList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getCompletedRequestList(debouncedFilters);
      setCompletedList(data.items);
      setCompletedListCount(data.totalCount);
    } catch {
      toast.error("Failed to fetch request more visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  useEffect(() => {
    setPageHeader({ 
      title: screenName,
      icon: <ScreenIcon className="h-6 w-6" />,
    });

    return () => setPageHeader(null);
  }, [screenName, ScreenIcon, setPageHeader]);

  useEffect(() => {
    loadCountries();
    fetchMiqaat()
  }, [loadCountries, fetchMiqaat]);

  useEffect(() => {
    fetchDashboardVisaSummary();
    fetchDraftVisaList();
    fetchSubmittedVisaList();
    fetchRequestMoreInfoVisaList();
    fetchIsPendingRequestList()
    fetchCompeletedRequestList()
  }, [
    fetchDashboardVisaSummary,
    fetchDraftVisaList,
    fetchSubmittedVisaList,
    fetchRequestMoreInfoVisaList,
    fetchIsPendingRequestList,
    fetchCompeletedRequestList
  ]);

  useEffect(() => {
    const loadWalletSummary = async () => {
      try {
        let res;

        if (isTourOperator && tourOperatorId) {

          res = await getWalletSummaryByTO(tourOperatorId);

          setWalletBalance(res.currentBalance ?? 0);
        } else {

          res = await getWalletSummary();

          setWalletBalance(res.grandTotalBalance ?? 0);
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((res as any).currencySymbol) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          setCurrencySymbol((res as any).currencySymbol);
        }
      } catch (error) {
        console.error("Failed to load wallet summary", error);
        toast.error("Failed to load wallet balance");
      }
    };

    loadWalletSummary();
  }, [isTourOperator, tourOperatorId]);

  // Mock Miqaat Tours data
  // const availableMiqaatTours = [
  //   {
  //     id: "MQ-2025-001",
  //     name: "Arbaeen Miqaat 2025",
  //     date: "2025-03-15",
  //     totalParticipantsAllowed: 100,
  //     availableQuota: 55,
  //   },
  //   {
  //     id: "MQ-2025-002",
  //     name: "Ramadan Miqaat 2025",
  //     date: "2025-04-10",
  //     totalParticipantsAllowed: 80,
  //     availableQuota: 48,
  //   },
  //   {
  //     id: "MQ-2025-003",
  //     name: "Shaaban Miqaat 2025",
  //     date: "2025-05-20",
  //     totalParticipantsAllowed: 60,
  //     availableQuota: 32,
  //   },
  //   {
  //     id: "MQ-2025-004",
  //     name: "Hajj Miqaat 2025",
  //     date: "2025-06-05",
  //     totalParticipantsAllowed: 120,
  //     availableQuota: 64,
  //   },
  // ];


  const getOverallStatusBadge = (status: string) => {
    const normalizedStatus = status.toLowerCase();
    switch (normalizedStatus) {
      case "draft":
        return {
          bg: "#FEF3C7",
          color: "#92400E",
          text: "Draft",
          icon: FileText,
        };
      case "submitted":
        return {
          bg: "#E0E7FF",
          color: "#4338CA",
          text: "Submitted",
          icon: FileText,
        };
      case "admin-approved":
        return {
          bg: "#DBEAFE",
          color: "#1E40AF",
          text: "Admin Approved",
          icon: CheckCircle,
        };
      case "documents-approved":
        return {
          bg: "#D1FAE5",
          color: "#065F46",
          text: "System Approved",
          icon: CheckCircle,
        };
      case "request-more-info":
        return {
          bg: "#FED7AA",
          color: "#9A3412",
          text: "Request More Info",
          icon: AlertCircle,
        };
      case "exported":
        return {
          bg: "#E0E7FF",
          color: "#3730A3",
          text: "Exported",
          icon: FileText,
        };
      case "uploaded":
        return {
          bg: "#CFFAFE",
          color: "#155E75",
          text: "Uploaded",
          icon: Upload,
        };
      case "batch-added":
        return {
          bg: "#F3E8FF",
          color: "#6B21A8",
          text: "Batch Added",
          icon: Users,
        };
      case "applicant-processing":
        return {
          bg: "#E0E7FF",
          color: "#3730A3",
          text: "Applicant Processing",
          icon: Clock,
        };
      case "visa-approved":
        return {
          bg: "#D1FAE5",
          color: "#065F46",
          text: "Visa Approved",
          icon: CheckCircle,
        };
      case "approved":
        return {
          bg: "#D1FAE5",
          color: "#065F46",
          text: "Approved",
          icon: CheckCircle,
        };
      case "rejected":
        return {
          bg: "#FEE2E2",
          color: "#991B1B",
          text: "Rejected",
          icon: XCircle,
        };
      case "do-not-process":
        return {
          bg: "#FEE2E2",
          color: "#991B1B",
          text: "Do Not Process",
          icon: Ban,
        };
      case "refunded":
        return {
          bg: "#FEF3C7",
          color: "#92400E",
          text: "Refunded",
          icon: DollarSign,
        };
      case "completed":
        return {
          bg: "#10B981",
          color: "white",
          text: "Completed",
          icon: CheckCircle,
        };
      default:
        return {
          bg: "#9CA3AF",
          color: "white",
          text: status,
          icon: AlertCircle,
        };
    }
  };


  const handleCompleteDraft = (id: number | string) => {
    toast.success("Opening draft to complete details...");
    onNavigate(`/visa-applicant-management/edit/${id}`);
  };

  const handleDeleteDraft = (id: string) => {
    setDraftToDelete(id);
    setDeleteDialogOpen(true);
  };

  const confirmDeleteDraft = async () => {
    if (!draftToDelete) return;

    try {
      setLoading(true);

      await deleteDraftVisaApplication(Number(draftToDelete));

      toast.success("Draft deleted successfully");

      setTotalDraftCount((prev) => Math.max(prev - 1, 0));

      await fetchDraftVisaList();

      setDeleteDialogOpen(false);
      setDraftToDelete(null);
    } catch (error) {
      toast.error("Failed to delete draft");
    } finally {
      setLoading(false);
    }
  };

  const cancelDeleteDraft = () => {
    setDeleteDialogOpen(false);
    setDraftToDelete(null);
  };


  const handleViewDetails = (applicant: DraftVisaItem) => {
    toast.info("Opening applicant details...");

    const applicationId = applicant.visaApplicationId;

    // IMPORTANT: use backend status
    const status = applicant.currentStatusCode?.toUpperCase();

    if (status === "REQUEST_MORE_INFO") {
      onNavigate(`/visa-applicant-more-info-view/${applicationId}`);
    } else {
      onNavigate(`/visa-applicant/view/${applicationId}`);
    }
  };

  // Handle Add Applicant button click
  const handleAddApplicantClick = () => {
    if (miqaatDetails.length === 0) {
      setSelectedTourOption("general");
      localStorage.setItem("tourType", "general");
      localStorage.removeItem("selectedMiqaat");
      toast.success("Proceeding to add applicant for General Tour");
      navigate("/visa-applicant-management/add");
    } else {
      setShowTourTypeDialog(true);
    }
  };

  // Handle proceed from tour selection dialog
  const handleProceedWithTourSelection = () => {
    //  If General Tour is selected
    if (selectedTourOption === "general") {
      localStorage.setItem("tourType", "general");
      localStorage.removeItem("selectedMiqaat");
      toast.success("Proceeding to add applicant for General Tour");
      navigate("/visa-applicant-management/add");
      return;
    } else {
      //  If Miqaat is selected
      const selectedMiqaat = miqaatDetails.find(
        (m) => m.rotationId === selectedTourOption
      );
      if (!selectedMiqaat) {
        toast.error("Invalid selection");
        return;
      }
      localStorage.setItem("tourType", "miqaat");
      localStorage.setItem("selectedMiqaat", JSON.stringify(selectedMiqaat));
      toast.success(
        `Proceeding to add applicant for ${selectedMiqaat.miqaatName}`
      );
      navigate("/visa-applicant-management/add");
    }
  };

  // Sorting functionality
  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };



  // Add these handlers near other handlers
  const handleSelectDraft = (applicant: DraftVisaItem) => {
    setSelectedDrafts(prev =>
      prev.some(a => a.visaApplicationId === applicant.visaApplicationId)
        ? prev.filter(a => a.visaApplicationId !== applicant.visaApplicationId)
        : [...prev, applicant]
    );
  };

  const handleSelectAllDrafts = () => {
    if (selectedDrafts.length === draftList.length) {
      setSelectedDrafts([]);
    } else {
      setSelectedDrafts(draftList);
    }
  };

  const handleSubmitSelectedDrafts = () => {
    // Now selectedDrafts contains full objects, so you can validate data here
    // console.log("Submitting drafts:", selectedDrafts);
    // Example validation: Check if all selected have passportNo
    const invalid = selectedDrafts.filter(a => !a.passportNo);
    if (invalid.length > 0) {
      toast.error("Some selected drafts are missing passport numbers.");
      return;
    }
    toast.success(`Submitted ${selectedDrafts.length} selected drafts`);
    // Add your submission logic here, e.g., API call
  };

  return (
    <div className="space-y-6 p-4 md:p-0">
      {loading && <FullScreenLoading />}
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center w-full gap-4">
          <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap w-full">
            <div className="relative flex-1 min-w-0">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
              <Input
                placeholder="Search by Application No, Name, ITS Number, or Passport..."
                value={searchTerm}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchTerm(value);
                  setFilterFields((prev) => ({
                    ...prev,
                    pageNo: 1,
                    submittedpageNo: 1,
                    requestMorepageNo: 1,
                    isPendingpageNo: 1,
                    CompletedpageNo: 1
                  }));
                }}
                className="h-10 pl-9 pr-9 shadow-sm"
              />
              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm("")}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  title="Clear search"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
          <Button
            variant="outline"
            onClick={() => setShowStatistics(!showStatistics)}
            className="border-[#5B9BD5]/30 text-[#5B9BD5] hover:bg-[#5B9BD5]/10 flex-1 sm:flex-initial text-sm"
          >
            {showStatistics ? (
              <ArrowUp className="w-5 h-5" />
            ) : (
              <BarChart3 className="w-5 h-5" />
            )}
          </Button>
          <Button
            variant="outline"
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            className={
              showAdvancedFilters
                ? "text-white"
                : "border-[#5B9BD5] text-[#5B9BD5] hover:bg-sky-50"
            }
            title="Advanced Filters"
          >
            <Filter className="w-4 h-4 sm:mr-0" />
          </Button>
          {canAdd && (
            <Button
              onClick={handleAddApplicantClick}
              className="text-white shadow-lg hover:opacity-90 flex-1 sm:flex-initial text-sm"
              style={{ backgroundColor: "#5B9BD5" }}
            >
              <Plus className="w-4 h-4 mr-2" />
              Add Applicant
            </Button>
          )}
        </div>
      </div>

      {/* Wallet Balance Card */}
      <Card className="bg-gradient-to-br from-[#5B9BD5] to-[#4A8BC2] text-white shadow-xl rounded-2xl">
        <CardContent className="p-4 md:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Wallet className="w-6 h-6 md:w-8 md:h-8" />
            <div>
              <p className="text-white text-lg">Available Balance</p>
              <p className="text-xl text-white md:text-2xl">
                {currencySymbol} {walletBalance.toLocaleString()}
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            className="bg-white/20 border-white/40 text-white hover:bg-white/30 rounded-xl w-full sm:w-auto text-sm"
            onClick={() => onNavigate("/my-wallet")}
          >
            View Wallet
          </Button>
        </CardContent>
      </Card>

      {/* Stats Cards */}
      {showStatistics && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          <Card className="bg-white shadow-lg border-[#5B9BD5]/20 rounded-2xl">
            <div className="flex items-center justify-between">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-4">
                <CardTitle
                  className="text-xs md:text-sm"
                  style={{ color: "#5B9BD5" }}
                >
                  Total
                </CardTitle>
                <Users className="w-5 h-5" style={{ color: "#5B9BD5" }} />
              </CardHeader>
              <CardContent className="p-3 md:p-4 pt-0 pb-2">
                {/* <div className="text-xl md:text-2xl text-gray-900">{totalApplicants}</div> */}
                <div className="text-xl md:text-xl text-end text-gray-900">
                  {dashboardSummary ? dashboardSummary?.total : '0'}
                </div>
                <p className="text-xs md:text-sm text-gray-600">Applicants</p>
              </CardContent>
            </div>
          </Card>

          <Card className="bg-white shadow-lg border-orange-200 rounded-2xl">
            <div className="flex items-center justify-between">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-4">
                <CardTitle className="text-xs md:text-sm text-orange-700">
                  Drafts
                </CardTitle>
                <FileText className="w-5 h-5 text-orange-500" />
              </CardHeader>
              <CardContent className="p-3 md:p-4 pt-0">
                {/* <div className="text-xl md:text-2xl text-orange-600">{totalDrafts}</div> */}
                <div className="text-xl md:text-2xl text-end text-orange-600">
                  {dashboardSummary ? dashboardSummary?.drafts : '0'}
                </div>
                <p className="text-xs md:text-sm text-gray-600">To Complete</p>
              </CardContent>
            </div>
          </Card>

          <Card className="bg-white shadow-lg border-blue-200 rounded-2xl">
            <div className="flex items-center justify-between">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-4">
                <CardTitle className="text-xs md:text-sm text-blue-700">
                  Under Review
                </CardTitle>
                <Clock className="w-5 h-5 text-blue-500" />
              </CardHeader>
              <CardContent className="p-3 md:p-4 pt-0">
                <div className="text-xl md:text-2xl text-end text-blue-600">
                  {dashboardSummary ? dashboardSummary?.underReview : '0'}
                </div>
                <p className="text-xs md:text-sm text-gray-600">Processing</p>
              </CardContent>
            </div>
          </Card>

          <Card className="bg-white shadow-lg border-green-200 rounded-2xl">
            <div className="flex items-center justify-between">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-4">
                <CardTitle className="text-xs md:text-sm text-green-700">
                  Completed
                </CardTitle>
                <CheckCircle className="w-5 h-5 text-green-500" />
              </CardHeader>
              <CardContent className="p-3 md:p-4 pt-0">
                {/* <div className="text-xl md:text-2xl text-orange-600">{totalDrafts}</div> */}
                <div className="text-xl md:text-2xl text-end text-green-600">
                  {dashboardSummary ? dashboardSummary?.completed : '0'}
                </div>
                <p className="text-xs md:text-xs text-gray-600">Visas Done</p>
              </CardContent>
            </div>
          </Card>
        </div>
      )}

      {/* Advanced Filters Section */}
      {showAdvancedFilters && (
        <Card className="border-[#5B9BD5]/30 bg-gradient-to-br from-sky-50/50 to-blue-50/50 shadow-lg rounded-2xl">
          <CardContent className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Filter className="w-5 h-5 text-[#5B9BD5]" />
                <h3 className="text-lg" style={{ color: "#5B9BD5" }}>
                  Advanced Filters
                </h3>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowAdvancedFilters(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* Application No Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-app-no" className="text-sm">
                  Application No
                </Label>
                <Input
                  id="filter-app-no"
                  placeholder="Search by application no..."
                  value={filterFields.applicationNo}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      applicationNo: e.target.value,
                      pageNo: 1,
                      submittedpageNo: 1,
                      requestMorepageNo: 1,
                      isPendingpageNo: 1,
                      CompletedpageNo: 1
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Applicant Name Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-name" className="text-sm">
                  Applicant Name
                </Label>
                <Input
                  id="filter-name"
                  placeholder="Search by name..."
                  value={filterFields.applicantName}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      applicantName: e.target.value,
                      pageNo: 1,
                      submittedpageNo: 1,
                      requestMorepageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* ITS Number Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-its" className="text-sm">
                  ITS Number
                </Label>
                <Input
                  id="filter-its"
                  placeholder="Search by ITS number..."
                  value={filterFields.itsNumber}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      itsNumber: e.target.value,
                      pageNo: 1,
                      submittedpageNo: 1,
                      requestMorepageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Passport Number Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-passport" className="text-sm">
                  Passport Number
                </Label>
                <Input
                  id="filter-passport"
                  placeholder="Search by passport no..."
                  value={filterFields.passportNo}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      passportNo: e.target.value,
                      pageNo: 1, // 🔥 RESET pagination
                      submittedpageNo: 1,
                      requestMorepageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Nationality Filter */}
              {/* <div className="space-y-2">
                <Label htmlFor="filter-nationality" className="text-sm">Nationality</Label>
                <Input
                  id="filter-nationality"
                  placeholder="Search by nationality..."
                  value={filterFields.nationality}
                  onChange={(e) =>
                    setFilterFields(prev => ({
                      ...prev,
                      nationality: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div> */}

              <div className="space-y-2">
                <Label htmlFor="nationality" className="text-sm">
                  Nationality<span className="text-red-500">*</span>
                </Label>
                <Select
                  value={filterFields.nationality}
                  onValueChange={(value) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      nationality: value,
                      pageNo: 1,
                      submittedpageNo: 1,
                      requestMorepageNo: 1,
                    }))
                  }
                >
                  <SelectTrigger id="nationality" className="bg-input-background text-sm">
                    <SelectValue placeholder="All" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="ALL">All Nationalities</SelectItem>
                    {countries?.map((country) => (
                      <SelectItem
                        key={country.countryId}
                        value={country.nationality ?? ""}
                      >
                        {country?.nationality}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {/* Status Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-status" className="text-sm">
                  Status
                </Label>
                <Select
                  value={filterFields.status || "all"}
                  onValueChange={(value) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      status: value === "all" ? "" : value,
                      pageNo: 1,
                    }))
                  }
                >
                  <SelectTrigger id="filter-status" className="bg-input-background h-9 text-sm">
                    <SelectValue placeholder="Select status..." />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Status</SelectItem>
                    <SelectItem value="submitted">Submitted</SelectItem>
                    <SelectItem value="admin-approved">
                      Admin Approved
                    </SelectItem>
                    <SelectItem value="documents-approved">
                      System Approved
                    </SelectItem>
                    <SelectItem value="exported">Exported</SelectItem>
                    <SelectItem value="uploaded">Uploaded</SelectItem>
                    <SelectItem value="batch-added">Batch Added</SelectItem>
                    <SelectItem value="applicant-processing">
                      Applicant Processing
                    </SelectItem>
                    <SelectItem value="visa-approved">Visa Approved</SelectItem>
                    <SelectItem value="do-not-process">
                      Do Not Process
                    </SelectItem>
                    <SelectItem value="refunded">Refunded</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Visa Required Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-visa-required" className="text-sm">
                  Visa Required
                </Label>
                <Select
                  value={filterFields.visaRequired || "all"}
                  onValueChange={(value) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      visaRequired: value === "all" ? "" : value,
                      pageNo: 1,
                    }))
                  }
                >
                  <SelectTrigger
                    id="filter-visa-required"
                    className="bg-input-background h-9 text-sm"
                  >
                    <SelectValue placeholder="Select visa requirement..." />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="true">Yes</SelectItem>
                    <SelectItem value="false">No</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            {/* Active Filters Summary & Clear Button */}
            {(filterFields.applicationNo ||
              filterFields.applicantName ||
              filterFields.itsNumber ||
              filterFields.passportNo ||
              filterFields.nationality ||
              filterFields.status ||
              filterFields.visaRequired) && (
                <div className="flex items-center justify-between gap-3 p-3 bg-white border border-[#5B9BD5]/30 rounded-lg mt-4">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-[#5B9BD5] mb-2">
                      Active Filters:
                    </p>
                    <div className="flex flex-wrap gap-1.5">
                      {filterFields.applicationNo && (
                        <Badge
                          variant="outline"
                          className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                        >
                          Application: {filterFields.applicationNo}
                        </Badge>
                      )}
                      {filterFields.applicantName && (
                        <Badge
                          variant="outline"
                          className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                        >
                          Name: {filterFields.applicantName}
                        </Badge>
                      )}
                      {filterFields.itsNumber && (
                        <Badge
                          variant="outline"
                          className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                        >
                          ITS: {filterFields.itsNumber}
                        </Badge>
                      )}
                      {filterFields.passportNo && (
                        <Badge
                          variant="outline"
                          className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                        >
                          Passport: {filterFields.passportNo}
                        </Badge>
                      )}
                      {filterFields.nationality && (
                        <Badge
                          variant="outline"
                          className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                        >
                          Nationality: {filterFields.nationality}
                        </Badge>
                      )}
                      {filterFields.status && (
                        <Badge
                          variant="outline"
                          className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                        >
                          Status:{" "}
                          {filterFields.status
                            .split("-")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            .join(" ")}
                        </Badge>
                      )}
                      {filterFields.visaRequired && (
                        <Badge
                          variant="outline"
                          className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                        >
                          Visa Required:{" "}
                          {filterFields.visaRequired === "true" ? "Yes" : "No"}
                        </Badge>
                      )}
                    </div>
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setFilterFields({
                        applicationNo: "",
                        applicantName: "",
                        itsNumber: "",
                        passportNo: "",
                        nationality: "",
                        status: "",
                        draftStatus: "",
                        visaRequired: "",
                        pageNo: 1,
                        submittedpageNo: 1,
                        requestMorepageNo: 1,
                        isPendingpageNo: 1,
                        CompletedpageNo: 1,
                        DraftpageSize: filterFields.DraftpageSize,
                        SubmiitedpageSize: filterFields.SubmiitedpageSize,
                        RequestMorepageSize: filterFields.RequestMorepageSize,
                        isPendingpageSize: filterFields.isPendingpageSize,
                        CompletedpageSize: filterFields.CompletedpageSize,
                        itsNo: "",
                      });
                    }}
                    className="text-red-600 border-red-300 hover:bg-red-50 flex-shrink-0"
                  >
                    <X className="w-4 h-4 mr-1" />
                    Clear All
                  </Button>
                </div>
              )}
          </CardContent>
        </Card>
      )}


      {/*DRAFT ACCORDION */}
      {
        <div className={`bg-white border border-default shadow-xs ${!isDraftOpen ? "rounded-xl" : ""}`} style={{ marginTop: "10px" }}>
          <h2>
            <button
              type="button"
              onClick={() => setIsDraftOpen(!isDraftOpen)}
              className={`flex items-center justify-between w-full p-4 font-medium text-body rounded-base hover:text-heading hover:bg-neutral-secondary-medium ${isDraftOpen ? "rounded-b-none shadow-none" : ""
                }`}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <FileText className="w-4 h-4 md:w-5 md:h-5 text-orange-700" />
                  <h2 className="text-orange-700 text-base md:text-lg">
                    Draft Applicants
                  </h2>
                  <Badge className="bg-orange-100 text-orange-700 text-xs">
                    {totalDraftCount ?? 0}
                  </Badge>
                </div>
              </div>
              {isDraftOpen ? (
                <ChevronUp className="w-5 h-5 text-orange-700" />
              ) : (
                <ChevronDown className="w-5 h-5 text-orange-700" />
              )}
            </button>
          </h2>

          {isDraftOpen && (
            <div className="border-default p-2 md:p-2">
              <div className="">
                <div className="">
                  <div className="space-y-3 mb-4">
                    {/*LOADING STATE */}
                    {/*NO DATA STATE */}
                    {!loading && draftList.length === 0 && <NoApplicantFound />}
                    {!loading &&
                      draftList.length > 0 &&
                      draftList.map((applicant: DraftVisaItem) => (
                        <Card
                          key={applicant?.visaApplicationId}
                          className="bg-white shadow-sm border-gray-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
                        >
                          <CardContent className="p-3">
                            <div className="flex items-center justify-between">
                              {/* Left side: Applicant details */}
                              <div className="flex items-center gap-3 flex-1">
                                <div className="flex-1 grid grid-cols-1 sm:grid-cols-4 gap-3">
                                  {/* Full Name with ITS Number */}
                                  <div>
                                    <p className="text-xs text-gray-500 mb-1">
                                      Full Name
                                    </p>
                                    <p className="text-sm text-gray-900 font-medium">
                                      {applicant.firstName} {applicant.middleName}{" "}
                                      {applicant.lastName}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-0.5">
                                      ITS: {applicant.itsNo || "N/A"}
                                    </p>
                                  </div>

                                  {/* Passport No. */}
                                  <div>
                                    <p className="text-xs text-gray-500 mb-1">
                                      Passport No.
                                    </p>
                                    <p className="text-sm text-gray-900 font-mono">
                                      {applicant.passportNo || "Not provided"}
                                    </p>
                                  </div>

                                  {/* Status */}
                                  <div>
                                    <p className="text-xs text-gray-500 mb-1">
                                      Status
                                    </p>
                                    <Badge
                                      variant="outline"
                                      className="bg-orange-50 text-orange-700 border-orange-300 text-xs"
                                    >
                                      Draft
                                    </Badge>
                                  </div>


                                  {/* miqaat code and rotation code. */}
                                  {applicant.miqaatCode && applicant.rotationCode ? (
                                    <div>
                                      <p className="text-xs text-gray-500 mb-1">
                                        Miqaat/Rotation
                                      </p>
                                      <Badge
                                        variant="outline"
                                        className="bg-purple-50 text-purple-700 border-purple-300 text-xs"
                                      >
                                        {applicant.miqaatCode || "-"} / {applicant.rotationCode || "-"}
                                      </Badge>
                                    </div>
                                  ) : <Badge
                                    variant="outline"
                                    className="h-5 bg-purple-50 text-purple-700 border-purple-300 text-xs"
                                  >
                                    General
                                  </Badge>}

                                </div>
                              </div>

                              {/* Right side: Actions */}
                              <div className="flex items-center gap-2 ml-3">
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  className="h-9 w-9 p-0 hover:bg-sky-50 text-gray-600 hover:text-[#5B9BD5]"
                                  onClick={() => handleViewDetails(applicant)}
                                  title="View Details"
                                >
                                  <Eye className="w-4 h-4" />
                                </Button>
                                {canEdit && (
                                  <Button
                                    size="sm"
                                    variant="ghost"
                                    className="h-9 w-9 p-0 hover:bg-sky-50 text-gray-600 hover:text-[#5B9BD5]"
                                    onClick={() =>
                                      handleCompleteDraft(
                                        String(applicant?.visaApplicationId),
                                      )
                                    }
                                    title="Edit Draft"
                                  >
                                    <Edit className="w-4 h-4" />
                                  </Button>
                                )}
                                {canDelete && (
                                  <Button
                                    size="sm"
                                    variant="ghost"
                                    className="h-9 w-9 p-0 hover:bg-red-50 text-red-600 hover:text-red-600"
                                    onClick={() =>
                                      handleDeleteDraft(
                                        String(applicant?.visaApplicationId),
                                      )
                                    }
                                    title="Delete Draft"
                                  >
                                    <Trash2 className="w-3 h-3" />
                                  </Button>
                                )}
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      ))}
                  </div>

                  {/* PAGINATION COMPONENT FOR DRAFT */}
                  <Pagination
                    totalItems={totalDraftCount}
                    itemsPerPage={filterFields.DraftpageSize}
                    currentPage={filterFields.pageNo}
                    onPageChange={(page) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        pageNo: page, // convert back to 0-based
                      }))
                    }
                    onPageSizeChange={(size) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        DraftpageSize: size,
                        pageNo: 1, // IMPORTANT: reset page
                      }))
                    }
                    label=""
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      }


      {/*DRAFT ACCORDION */}
      {
        <div className={`hidden bg-white border border-default shadow-xs ${!isDraftOpen ? "rounded-xl" : ""}`} style={{ marginTop: "10px" }}>
          <h2>
            <div
              onClick={() => setIsDraftOpen(!isDraftOpen)}
              className={`flex items-center justify-between w-full p-4 font-medium text-body rounded-base hover:text-heading hover:bg-neutral-secondary-medium cursor-pointer ${isDraftOpen ? "rounded-b-none shadow-none" : ""
                }`}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <FileText className="w-4 h-4 md:w-5 md:h-5 text-orange-700" />
                  <h2 className="text-orange-700 text-base md:text-lg">
                    Draft Applicants
                  </h2>
                  <Badge className="bg-orange-100 text-orange-700 text-xs">
                    {totalDraftCount ?? 0}
                  </Badge>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {isDraftOpen ? (
                  <ChevronUp className="w-5 h-5 text-orange-700" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-orange-700" />
                )}
              </div>
            </div>
          </h2>

          {isDraftOpen && (
            <div className="border-default p-2 md:p-2">
              <div className="">
                <div className="">
                  {/* Select All Checkbox */}
                  <div className="flex justify-between items-center gap-2 p-4">
                    <div>
                      <input
                        type="checkbox"
                        checked={selectedDrafts.length === draftList.length && draftList.length > 0}
                        onChange={handleSelectAllDrafts}
                        className="w-4 h-4"
                      />
                      <label className="text-sm text-gray-900 font-medium ml-2">Select All</label>
                    </div>
                    <div>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering the accordion toggle
                          handleSubmitSelectedDrafts();
                        }}
                        className="border-orange-300 text-orange-700 hover:bg-orange-50"
                        disabled={selectedDrafts.length === 0}
                      >
                        Submit Selected ({selectedDrafts.length})
                      </Button>
                    </div>
                  </div>

                  <div className="space-y-3 mb-4">
                    {/*LOADING STATE */}
                    {/*NO DATA STATE */}
                    {!loading && draftList.length === 0 && <NoApplicantFound />}
                    {!loading &&
                      draftList.length > 0 &&
                      draftList.map((applicant: DraftVisaItem) => (
                        <Card
                          key={applicant?.visaApplicationId}
                          className="bg-white shadow-sm border-gray-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
                        >
                          <CardContent className="p-3">
                            <div className="flex items-center justify-between">
                              {/* Checkbox and Left side: Applicant details */}
                              <div className="flex items-center gap-3 flex-1">
                                <input
                                  type="checkbox"
                                  checked={selectedDrafts.some(a => a.visaApplicationId === applicant.visaApplicationId)}
                                  onChange={() => handleSelectDraft(applicant)}
                                  className="w-4 h-4"
                                />
                                <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-3">
                                  {/* Full Name with ITS Number */}
                                  <div>
                                    <p className="text-xs text-gray-500 mb-1">
                                      Full Name
                                    </p>
                                    <p className="text-sm text-gray-900 font-medium">
                                      {applicant.firstName} {applicant.middleName}{" "}
                                      {applicant.lastName}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-0.5">
                                      ITS: {applicant.itsNo || "N/A"}
                                    </p>
                                  </div>

                                  {/* Passport No. */}
                                  <div>
                                    <p className="text-xs text-gray-500 mb-1">
                                      Passport No.
                                    </p>
                                    <p className="text-sm text-gray-900 font-mono">
                                      {applicant.passportNo || "Not provided"}
                                    </p>
                                  </div>

                                  {/* Status */}
                                  <div>
                                    <p className="text-xs text-gray-500 mb-1">
                                      Status
                                    </p>
                                    <Badge
                                      variant="outline"
                                      className="bg-orange-50 text-orange-700 border-orange-300 text-xs"
                                    >
                                      Draft
                                    </Badge>
                                  </div>
                                </div>
                              </div>

                              {/* Right side: Actions */}
                              <div className="flex items-center gap-2 ml-3">
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  className="h-9 w-9 p-0 hover:bg-sky-50 text-gray-600 hover:text-[#5B9BD5]"
                                  onClick={() => handleViewDetails(applicant)}
                                  title="View Details"
                                >
                                  <Eye className="w-4 h-4" />
                                </Button>
                                {canEdit && (
                                  <Button
                                    size="sm"
                                    variant="ghost"
                                    className="h-9 w-9 p-0 hover:bg-sky-50 text-gray-600 hover:text-[#5B9BD5]"
                                    onClick={() =>
                                      handleCompleteDraft(
                                        String(applicant?.visaApplicationId),
                                      )
                                    }
                                    title="Edit Draft"
                                  >
                                    <Edit className="w-4 h-4" />
                                  </Button>
                                )}
                                {canDelete && (
                                  <Button
                                    size="sm"
                                    variant="ghost"
                                    className="h-9 w-9 p-0 hover:bg-red-50 text-red-600 hover:text-red-600"
                                    onClick={() =>
                                      handleDeleteDraft(
                                        String(applicant?.visaApplicationId),
                                      )
                                    }
                                    title="Delete Draft"
                                  >
                                    <Trash2 className="w-3 h-3" />
                                  </Button>
                                )}
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      ))}
                  </div>

                  {/* PAGINATION COMPONENT FOR DRAFT */}
                  <Pagination
                    totalItems={totalDraftCount}
                    itemsPerPage={filterFields.DraftpageSize}
                    currentPage={filterFields.pageNo}
                    onPageChange={(page) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        pageNo: page, // convert back to 0-based
                      }))
                    }
                    onPageSizeChange={(size) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        DraftpageSize: size,
                        pageNo: 1, // IMPORTANT: reset page
                      }))
                    }
                    label=""
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      }


      {/* SUBMITTED APPLICANTS ACCORDION*/}
      {
        <div className={`bg-white border border-default shadow-xs ${!isSubmittedOpen ? "rounded-xl" : ""}`} style={{ marginTop: "10px" }}>
          <h2>
            <div
              onClick={() => setIsSubmittedOpen(!isSubmittedOpen)}
              className={`flex items-center justify-between w-full p-4 font-medium text-body rounded-base hover:text-heading hover:bg-neutral-secondary-medium ${isSubmittedOpen ? "rounded-b-none shadow-none" : ""
                }`}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <Users
                    className="w-4 h-4 md:w-5 md:h-5"
                    style={{ color: "#5B9BD5" }}
                  />
                  <h2 style={{ color: "#5B9BD5" }} className="text-base md:text-lg">
                    Submitted Applicants
                  </h2>
                  <Badge className="bg-[#5B9BD5] text-white text-xs">
                    {totalSubmittedListCount}
                  </Badge>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row items-start sm:items-center justify-between gap-3 text-xs">
                <div>
                  {isSubmittedOpen ? (
                    <ChevronUp className="w-5 h-5 text-blue-500" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-blue-500" />
                  )}
                </div>
              </div>
            </div>
          </h2>

          {isSubmittedOpen && (
            <div className="">
              <div className="flex justify-end items-center gap-2 mb-2">
                {/* <Button
                  onClick={handleExportApplicants}
                  variant="outline"
                  className="border-blue-500 text-blue-700 hover:bg-green-50 rounded-xl text-xs w-full sm:w-auto"
                >
                  <FileSpreadsheet className="w-3 h-3 mr-2" />
                  Export Applicants
                </Button> */}
              </div>
              <div className="bg-white shadow-lg border-[#5B9BD5]/20 overflow-hidden">
                <div>
                  {/* Desktop Table View */}
                  <div className="hidden md:block overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-[#5B9BD5]/10">
                        <tr>
                          <th
                            className="text-left p-3 text-xs text-gray-900 cursor-pointer select-none hover:bg-[#5B9BD5]/20"
                            onClick={() => handleSort("applicationNo")}
                          >
                            <div className="flex items-center gap-1">
                              Application No
                              {sortColumn === "applicationNo" ? (
                                sortDirection === "asc" ? (
                                  <ArrowUp className="w-3 h-3" />
                                ) : (
                                  <ArrowDown className="w-3 h-3" />
                                )
                              ) : (
                                <ArrowUpDown className="w-3 h-3 opacity-30" />
                              )}
                            </div>
                          </th>
                          <th
                            className="text-left p-3 text-xs text-gray-900 cursor-pointer select-none hover:bg-[#5B9BD5]/20"
                            onClick={() => handleSort("name")}
                          >
                            <div className="flex items-center gap-1">
                              Full Name
                              {sortColumn === "name" ? (
                                sortDirection === "asc" ? (
                                  <ArrowUp className="w-3 h-3" />
                                ) : (
                                  <ArrowDown className="w-3 h-3" />
                                )
                              ) : (
                                <ArrowUpDown className="w-3 h-3 opacity-30" />
                              )}
                            </div>
                          </th>
                          <th
                            className="text-left p-3 text-xs text-gray-900 cursor-pointer select-none hover:bg-[#5B9BD5]/20"
                            onClick={() => handleSort("nationality")}
                          >
                            <div className="flex items-center gap-1">
                              Passport No / Nationality
                              {sortColumn === "nationality" ? (
                                sortDirection === "asc" ? (
                                  <ArrowUp className="w-3 h-3" />
                                ) : (
                                  <ArrowDown className="w-3 h-3" />
                                )
                              ) : (
                                <ArrowUpDown className="w-3 h-3 opacity-30" />
                              )}
                            </div>
                          </th>
                          <th
                            className="text-left p-3 text-xs text-gray-900 cursor-pointer select-none hover:bg-[#5B9BD5]/20"
                            onClick={() => handleSort("age")}
                          >
                            <div className="flex items-center gap-1">
                              Age / DOB
                              {sortColumn === "age" ? (
                                sortDirection === "asc" ? (
                                  <ArrowUp className="w-3 h-3" />
                                ) : (
                                  <ArrowDown className="w-3 h-3" />
                                )
                              ) : (
                                <ArrowUpDown className="w-3 h-3 opacity-30" />
                              )}
                            </div>
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Visa Required
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Overall Status
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {submittedApplicantsList.length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-center">
                              <NoApplicantFound />
                            </td>
                          </tr>
                        ) : (
                          submittedApplicantsList?.map((applicant) => {
                            // const statusBadge = getOverallStatusBadge(applicant.overallStatus);
                            const statusBadge = getOverallStatusBadge(
                              applicant.currentStatusCode,
                            );
                            const StatusIcon = statusBadge.icon;
                            return (
                              <tr
                                key={applicant.visaApplicationId}
                                className="border-b border-gray-100 hover:bg-[#5B9BD5]/5 cursor-pointer"
                                onClick={() => handleViewDetails(applicant)}
                              >
                                <td className="p-3">
                                  <div>
                                    <span
                                      className="text-xs block"
                                      style={{ color: "#5B9BD5" }}
                                    >
                                      {applicant.applicationNumber || "N/A"}
                                    </span>
                                    {applicant.batchNumber && (
                                      <span className="text-[10px] text-purple-600 block mt-0.5">
                                        {applicant.batchNumber || "N/A"}
                                      </span>
                                    )}
                                  </div>
                                </td>
                                <td className="p-3">
                                  <div>
                                    <p className="text-xs text-gray-900">
                                      {applicant.title} {applicant.firstName}{" "}
                                      {applicant.middleName} {applicant.lastName}
                                    </p>
                                    <p className="text-[10px] text-gray-500 mt-0.5">
                                      {/* {applicant.itsNo || applicant.loginId} */}
                                      {applicant.itsNo || "N/A"}
                                    </p>
                                  </div>
                                </td>
                                <td className="p-3">
                                  <div>
                                    <p className="text-xs text-gray-900">
                                      {applicant.passportNo || "-"}
                                    </p>
                                    <p className="text-[10px] text-gray-500 mt-0.5">
                                      {applicant.passportNationality}
                                    </p>
                                  </div>
                                </td>
                                <td className="p-3">
                                  <div>
                                    <p className="text-xs text-gray-600">
                                      {applicant.age} years
                                    </p>
                                    <p className="text-[10px] text-gray-500 mt-0.5">
                                      {applicant.dateOfBirth.split("T")[0]}
                                    </p>
                                  </div>
                                </td>
                                <td className="p-3 text-center">
                                  <div className="flex flex-col items-center gap-0.5">
                                    <Badge
                                      className="text-[10px] flex items-center gap-0.5 w-fit px-1.5 py-0.5"
                                      style={{
                                        backgroundColor: applicant.visaRequired
                                          ? "#D1FAE5"
                                          : "#FEE2E2",
                                        color: applicant.visaRequired
                                          ? "#065F46"
                                          : "#991B1B",
                                      }}
                                    >
                                      {applicant.visaRequired ? "Yes" : "No"}
                                    </Badge>
                                    <span className="text-[10px] text-gray-600">
                                      $ {applicant.visaFee || 0}
                                    </span>
                                  </div>
                                </td>
                                <td className="p-3 text-center">
                                  <Badge
                                    className="text-[10px] mx-auto w-fit px-2 py-1.5"
                                    style={{
                                      backgroundColor: statusBadge.bg,
                                      color: statusBadge.color,
                                    }}
                                  >
                                    <div className="flex flex-col items-center">
                                      <div className="flex items-center gap-1">
                                        <StatusIcon className="w-2.5 h-2.5" />
                                        <span>{statusBadge.text}</span>
                                      </div>
                                    </div>
                                  </Badge>
                                </td>
                                <td className="p-3 text-center">
                                  <div className="flex items-center gap-2 ml-3">
                                    <Button
                                      size="sm"
                                      variant="ghost"
                                      className="h-9 w-9 p-0 hover:bg-sky-50 text-blue-600 hover:text-[#5B9BD5]"
                                      onClick={() => handleViewDetails(applicant)}
                                      title="View Details"
                                    >
                                      <Eye className="w-4 h-4" />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            );
                          }))}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View */}
                  <div className="md:hidden space-y-3 p-2">
                    {submittedApplicantsList.length === 0 && <NoApplicantFound />}
                    {submittedApplicantsList &&
                      submittedApplicantsList?.map((applicant) => {
                        const statusBadge = getOverallStatusBadge(
                          applicant.currentStatusCode,
                        );
                        const StatusIcon = statusBadge.icon;
                        return (
                          <Card
                            key={applicant.visaApplicationId}
                            className="bg-white shadow-sm border-gray-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
                            onClick={() => handleViewDetails(applicant)}
                          >
                            <CardContent className="p-3">
                              <div className="">
                                {/* Application Number */}
                                <div>
                                  <p className="text-xs text-gray-500">
                                    Application No
                                  </p>
                                  <p
                                    className="text-sm font-medium"
                                    style={{ color: "#5B9BD5" }}
                                  >
                                    {applicant.applicationNumber}
                                  </p>
                                  {applicant.batchNumber && (
                                    <span className="text-[10px] text-purple-600 block mt-0.5">
                                      {applicant.batchNumber || "N/A"}
                                    </span>
                                  )}
                                </div>

                                {/* Full Name and ITS */}
                                <div>
                                  <p className="text-xs text-gray-500">Full Name</p>
                                  <p className="text-sm text-gray-900">
                                    {applicant.title} {applicant.firstName}{" "}
                                    {applicant.middleName} {applicant.lastName}
                                  </p>
                                  <p className="text-[10px] text-gray-500 mt-0.5">
                                    {/* ITS: {applicant.itsNumber || applicant.loginId} */}
                                    ITS: {applicant.itsNo || "N/A"}
                                  </p>
                                </div>

                                {/* Passport and Nationality */}
                                <div className="grid grid-cols-2 gap-2">
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Passport No.
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.passportNo || "-"}
                                    </p>
                                  </div>
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Nationality
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.passportNationality}
                                    </p>
                                  </div>
                                </div>

                                {/* Age and DOB */}
                                <div>
                                  <p className="text-xs text-gray-500">Age / DOB</p>
                                  <p className="text-sm text-gray-600">
                                    {applicant.age} years •{" "}
                                    {applicant.dateOfBirth.split("T")[0]}
                                  </p>
                                </div>

                                {/* Visa Required and Cost */}
                                <div className="flex items-center gap-2">
                                  <div>
                                    <p className="text-xs text-gray-500 mb-1">
                                      Visa Required
                                    </p>
                                    <Badge
                                      className="text-[10px]"
                                      style={{
                                        backgroundColor: applicant.visaRequired
                                          ? "#D1FAE5"
                                          : "#FEE2E2",
                                        color: applicant.visaRequired
                                          ? "#065F46"
                                          : "#991B1B",
                                      }}
                                    >
                                      {applicant.visaRequired ? "Yes" : "No"}
                                    </Badge>
                                    <span className="text-[10px] text-gray-600 ml-2">
                                      ${applicant.visaFee || 0}
                                    </span>
                                  </div>
                                </div>

                                {/* Overall Status */}
                                <div>
                                  <p className="text-xs text-gray-500 mb-1">Status</p>
                                  <Badge
                                    className="text-[10px] px-2 py-1"
                                    style={{
                                      backgroundColor: statusBadge.bg,
                                      color: statusBadge.color,
                                    }}
                                  >
                                    <div className="flex items-center gap-1">
                                      <StatusIcon className="w-2.5 h-2.5" />
                                      <span>{statusBadge.text}</span>
                                    </div>
                                  </Badge>
                                </div>
                                <div className="pt-2">
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className="w-full border-blue-300 text-blue-700 hover:bg-blue-50"
                                    onClick={() => handleViewDetails(applicant)}
                                  >
                                    <Eye className="w-4 h-4 mr-2" />
                                    View & Update
                                  </Button>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        );
                      })}
                  </div>

                  {/* PAGINATION FOR SUBMITTED APPLICANTS */}
                  <Pagination
                    totalItems={totalSubmittedListCount}
                    itemsPerPage={filterFields.SubmiitedpageSize}
                    currentPage={filterFields.submittedpageNo}
                    onPageChange={(page) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        submittedpageNo: page, // convert back to 0-based
                      }))
                    }
                    onPageSizeChange={(size) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        SubmiitedpageSize: size,
                        submittedpageNo: 1, // IMPORTANT: reset page
                      }))
                    }
                    label="applicants"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      }
      {/* SUBMITTED APPLICANTS END */}


      {/* REQUEST MORE INFO ACCORDION */}
      {
        <div className={`bg-white border border-default shadow-xs ${!isReqMoreOpen ? "rounded-xl" : ""}`} style={{ marginTop: "10px" }}>
          <h2>
            <button
              type="button"
              onClick={() => setIsReqMoreOpen(!isReqMoreOpen)}
              className={`flex items-center justify-between w-full p-4 font-medium text-body rounded-base hover:text-heading hover:bg-neutral-secondary-medium ${isReqMoreOpen ? "rounded-b-none shadow-none" : ""
                }`}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <AlertCircle className="w-4 h-4 md:w-5 md:h-5 text-red-500" />
                  <h2 className="text-red-500 text-base md:text-lg">
                    Request More Info
                  </h2>
                  <Badge className="bg-red-100 text-red-700 text-xs">
                    {totalRequestListCount ?? 0}
                  </Badge>
                </div>
              </div>
              {isReqMoreOpen ? (
                <ChevronUp className="w-5 h-5 text-red-500" />
              ) : (
                <ChevronDown className="w-5 h-5 text-red-500" />
              )}
            </button>
          </h2>

          {isReqMoreOpen && (
            <div className="">
              <div className="bg-white shadow-lg overflow-hidden">
                <div>
                  <div className="hidden md:block overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-red-100">
                        <tr>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Application No
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Full Name
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Passport No / Nationality
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Miqaat / Rotation
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Visa Required
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Remarks
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {RequestMoreList.length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-center">
                              <NoApplicantFound />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {RequestMoreList &&
                              RequestMoreList?.map((applicant) => {
                                return (
                                  <tr
                                    key={applicant.visaApplicationId}
                                    className="border-b border-red-100 hover:bg-red-50/50"
                                  >
                                    <td className="p-3">
                                      <div>
                                        <span className="text-xs block text-red-700">
                                          {applicant.applicationNumber}
                                        </span>
                                        {/* {applicant.linkedTourNo && (
                                  <span className="text-[10px] text-gray-500 block mt-0.5">
                                    {applicant.linkedTourNo}
                                  </span>
                                )} */}
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.title} {applicant.firstName}{" "}
                                          {applicant.middleName}{" "}
                                          {applicant.lastName}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {/* {applicant.itsNo || applicant.loginId} */}
                                          {applicant.itsNo ?? "N/A"}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.passportNo || "-"}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {applicant.nationality}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.miqaatCode || "-"}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {applicant.rotationCode || "-"}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="p-3 text-center">
                                      <div className="flex flex-col items-center gap-0.5">
                                        <Badge
                                          className="text-[10px] flex items-center gap-0.5 w-fit px-1.5 py-0.5"
                                          style={{
                                            backgroundColor: applicant.visaRequired
                                              ? "#D1FAE5"
                                              : "#FEE2E2",
                                            color: applicant.visaRequired
                                              ? "#065F46"
                                              : "#991B1B",
                                          }}
                                        >
                                          {applicant.visaRequired ? "Yes" : "No"}
                                        </Badge>
                                        <span className="text-[10px] text-gray-600">
                                          ${applicant.visaFee || 0}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <p className="text-xs text-red-600">
                                        {applicant.lastStatusMessage || "No remark provided"}
                                      </p>
                                    </td>
                                    <td className="p-3">
                                      <div className="flex items-center justify-center">
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          className="h-8 w-8 p-0 hover:bg-red-50 text-red-600"
                                          onClick={() => handleViewDetails(applicant)}
                                          title="View & Update"
                                        >
                                          <Eye className="w-4 h-4" />
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View for Request More Info */}
                  <div className="md:hidden space-y-3 p-2">
                    {RequestMoreList.length === 0 && <NoApplicantFound />}
                    {RequestMoreList.length > 0 &&
                      RequestMoreList.map((applicant) => {
                        return (
                          <Card
                            key={applicant.visaApplicationId}
                            className="bg-white shadow-sm border-red-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
                          >
                            <CardContent className="p-3">
                              <div className="space-y-2">
                                {/* Application Number */}
                                <div>
                                  <p className="text-xs text-gray-500">
                                    Application No.
                                  </p>
                                  <p className="text-sm font-medium text-red-700">
                                    {applicant.applicationNumber}
                                  </p>
                                  {/* {applicant.linkedTourNo && (
                                <p className="text-[10px] text-gray-500 mt-0.5">
                                  {applicant.linkedTourNo}
                                </p>
                              )} */}
                                </div>

                                {/* Full Name and ITS */}
                                <div>
                                  <p className="text-xs text-gray-500">Full Name</p>
                                  <p className="text-sm text-gray-900">
                                    {applicant.title} {applicant.firstName}{" "}
                                    {applicant.middleName} {applicant.lastName}
                                  </p>
                                  <p className="text-[10px] text-gray-500 mt-0.5">
                                    {/* ITS: {applicant.itsNumber || applicant.loginId} */}
                                    ITS: {applicant.itsNo || "N/A"}
                                  </p>
                                </div>

                                {/* Passport and Nationality */}
                                <div className="grid grid-cols-2 gap-2">
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Passport No.
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.passportNo || "-"}
                                    </p>
                                  </div>
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Nationality
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.nationality}
                                    </p>
                                  </div>
                                </div>

                                {/* Visa Required and Cost */}
                                <div>
                                  <p className="text-xs text-gray-500 mb-1">
                                    Visa Required
                                  </p>
                                  <Badge
                                    className="text-[10px]"
                                    style={{
                                      backgroundColor: applicant.visaRequired
                                        ? "#D1FAE5"
                                        : "#FEE2E2",
                                      color: applicant.visaRequired
                                        ? "#065F46"
                                        : "#991B1B",
                                    }}
                                  >
                                    {applicant.visaRequired ? "Yes" : "No"}
                                  </Badge>
                                  <span className="text-[10px] text-gray-600 ml-2">
                                    ${applicant.visaFee || 0}
                                  </span>
                                </div>

                                {/* Remarks */}
                                <div>
                                  <p className="text-xs text-gray-500 mb-1">
                                    Remarks
                                  </p>
                                  <p className="text-xs text-red-600">
                                    {applicant.remarks || "No remark provided"}
                                  </p>
                                </div>

                                {/* Action Button */}
                                <div className="pt-2">
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className="w-full border-red-300 text-red-700 hover:bg-red-50"
                                    onClick={() => handleViewDetails(applicant)}
                                  >
                                    <Eye className="w-4 h-4 mr-2" />
                                    View & Update
                                  </Button>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        );
                      })}
                  </div>

                  {/* PAGINATION FOR REQUEST MORE INFO */}
                  <Pagination
                    totalItems={totalRequestListCount}
                    itemsPerPage={filterFields.RequestMorepageSize}
                    currentPage={filterFields.requestMorepageNo}
                    onPageChange={(page) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        requestMorepageNo: page, // convert back to 0-based
                      }))
                    }
                    onPageSizeChange={(size) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        RequestMorepageSize: size,
                        requestMorepageNo: 1,
                      }))
                    }
                    label="applicants"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      }
      {/* REQUEST MORE INFO APPLICANTS SECTION END */}


      {/* ISPENDING ACCORDION APPLICANTS SECTION */}
      {
        <div className={`bg-white border border-default shadow-xs ${!isPendingOpen ? "rounded-xl" : ""}`} style={{ marginTop: "10px" }}>
          <h2>
            <button
              type="button"
              onClick={() => setIsPendingOpen(!isPendingOpen)}
              className={`flex items-center justify-between w-full p-4 font-medium text-body rounded-base hover:text-heading hover:bg-neutral-secondary-medium ${isPendingOpen ? "rounded-b-none shadow-none" : ""
                }`}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <PencilRuler className="w-4 h-4 md:w-5 md:h-5 text-orange-600" />
                  <h2 className="text-orange-600 text-base md:text-lg">
                    In-Progress
                  </h2>
                  <Badge className="bg-orange-200 text-orange-600 text-xs">
                    {totalIsPendingListCount ?? 0}
                  </Badge>
                </div>
              </div>
              {isPendingOpen ? (
                <ChevronUp className="w-5 h-5 text-orange-600" />
              ) : (
                <ChevronDown className="w-5 h-5 text-orange-600" />
              )}
            </button>
          </h2>

          {isPendingOpen && (
            <div className="">
              <div className="bg-white shadow-lg overflow-hidden">
                <div>
                  <div className="hidden md:block overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-orange-200">
                        <tr>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Application No
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Full Name
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Passport No / Nationality
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Visa Required
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Remarks
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isPendingList.length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-center">
                              <NoApplicantFound />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {isPendingList &&
                              isPendingList?.map((applicant) => {
                                return (
                                  <tr
                                    key={applicant.visaApplicationId}
                                    className="border-b border-orange-100 hover:bg-orange-50/50"
                                  >
                                    <td className="p-3">
                                      <div>
                                        <span className="text-xs block text-orange-700">
                                          {applicant.applicationNumber}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.title} {applicant.firstName}{" "}
                                          {applicant.middleName}{" "}
                                          {applicant.lastName}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {/* {applicant.itsNo || applicant.loginId} */}
                                          {applicant.itsNo ?? "N/A"}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.passportNo || "-"}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {applicant.nationality}
                                        </p>
                                      </div>
                                    </td>

                                    <td className="p-3 text-center">
                                      <div className="flex flex-col items-center gap-0.5">
                                        <Badge
                                          className="text-[10px] flex items-center gap-0.5 w-fit px-1.5 py-0.5"
                                          style={{
                                            backgroundColor: applicant.visaRequired
                                              ? "#D1FAE5"
                                              : "#FEE2E2",
                                            color: applicant.visaRequired
                                              ? "#065F46"
                                              : "#991B1B",
                                          }}
                                        >
                                          {applicant.visaRequired ? "Yes" : "No"}
                                        </Badge>
                                        <span className="text-[10px] text-gray-600">
                                          ${applicant.visaFee || 0}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <p className="text-xs text-red-600">
                                        {applicant.remarks || "No remark provided"}
                                      </p>
                                    </td>
                                    <td className="p-3">
                                      <div className="flex items-center justify-center">
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          className="h-8 w-8 p-0 hover:bg-red-50 text-red-600"
                                          onClick={() => handleViewDetails(applicant)}
                                          title="View & Update"
                                        >
                                          <Eye className="w-4 h-4" />
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View for Request More Info */}
                  <div className="md:hidden space-y-3 p-2">
                    {isPendingList.length === 0 && <NoApplicantFound />}
                    {isPendingList.length > 0 &&
                      isPendingList.map((applicant) => {
                        return (
                          <Card
                            key={applicant.visaApplicationId}
                            className="bg-white shadow-sm border-red-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
                          >
                            <CardContent className="p-3">
                              <div className="space-y-2">
                                {/* Application Number */}
                                <div>
                                  <p className="text-xs text-gray-500">
                                    Application No.
                                  </p>
                                  <p className="text-sm font-medium text-red-700">
                                    {applicant.applicationNumber}
                                  </p>
                                </div>
                                {/* Full Name and ITS */}
                                <div>
                                  <p className="text-xs text-gray-500">Full Name</p>
                                  <p className="text-sm text-gray-900">
                                    {applicant.title} {applicant.firstName}{" "}
                                    {applicant.middleName} {applicant.lastName}
                                  </p>
                                  <p className="text-[10px] text-gray-500 mt-0.5">
                                    {/* ITS: {applicant.itsNumber || applicant.loginId} */}
                                    ITS: {applicant.itsNo || "N/A"}
                                  </p>
                                </div>

                                {/* Passport and Nationality */}
                                <div className="grid grid-cols-2 gap-2">
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Passport No.
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.passportNo || "-"}
                                    </p>
                                  </div>
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Nationality
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.nationality}
                                    </p>
                                  </div>
                                </div>

                                {/* Miqaat and Rotation */}
                                <div className="grid grid-cols-2 gap-2">
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Miqaat
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.miqaatCode || "-"}
                                    </p>
                                  </div>
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Rotation
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.rotationCode || "-"}
                                    </p>
                                  </div>
                                </div>

                                {/* Visa Required and Cost */}
                                <div>
                                  <p className="text-xs text-gray-500 mb-1">
                                    Visa Required
                                  </p>
                                  <Badge
                                    className="text-[10px]"
                                    style={{
                                      backgroundColor: applicant.visaRequired
                                        ? "#D1FAE5"
                                        : "#FEE2E2",
                                      color: applicant.visaRequired
                                        ? "#065F46"
                                        : "#991B1B",
                                    }}
                                  >
                                    {applicant.visaRequired ? "Yes" : "No"}
                                  </Badge>
                                  <span className="text-[10px] text-gray-600 ml-2">
                                    ${applicant.visaFee || 0}
                                  </span>
                                </div>

                                {/* Remarks */}
                                <div>
                                  <p className="text-xs text-gray-500 mb-1">
                                    Remarks
                                  </p>
                                  <p className="text-xs text-red-600">
                                    {applicant.remarks || "No remark provided"}
                                  </p>
                                </div>

                                {/* Action Button */}
                                <div className="pt-2">
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className="w-full border-red-300 text-red-700 hover:bg-red-50"
                                    onClick={() => handleViewDetails(applicant)}
                                  >
                                    <Eye className="w-4 h-4 mr-2" />
                                    View & Update
                                  </Button>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        );
                      })}
                  </div>

                  {/* PAGINATION FOR REQUEST MORE INFO */}
                  <Pagination
                    totalItems={totalIsPendingListCount}
                    itemsPerPage={filterFields.isPendingpageSize}
                    currentPage={filterFields.isPendingpageNo}
                    onPageChange={(page) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        requestMorepageNo: page, // convert back to 0-based
                      }))
                    }
                    onPageSizeChange={(size) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        isPendingpageSize: size,
                        isPendingpageNo: 1,
                      }))
                    }
                    label="applicants"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      }
      {/* ISPENDING APPLICANTS SECTION END */}


      {/* COMPLETED ACCORDION SECTION */}
      {
        <div className={`bg-white border border-default shadow-xs ${!isCompletedOpen ? "rounded-xl" : ""}`} style={{ marginTop: "10px" }}>
          <h2>
            <button
              type="button"
              onClick={() => setIsCompletedOpen(!isCompletedOpen)}
              className={`flex items-center justify-between w-full p-4 font-medium text-body rounded-base hover:text-heading hover:bg-neutral-secondary-medium ${isCompletedOpen ? "rounded-b-none shadow-none" : ""
                }`}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <UserRoundCheck className="w-4 h-4 md:w-5 md:h-5 text-green-600" />
                  <h2 className="text-green-600 text-base md:text-lg">
                    Completed
                  </h2>
                  <Badge className="bg-green-100 text-green-700 text-xs">
                    {totalCompletedListCount ?? 0}
                  </Badge>
                </div>
              </div>
              {isCompletedOpen ? (
                <ChevronUp className="w-5 h-5 text-green-600" />
              ) : (
                <ChevronDown className="w-5 h-5 text-green-600" />
              )}
            </button>
          </h2>

          {isCompletedOpen && (
            <div className="">
              <div className="bg-white shadow-lg overflow-hidden">
                <div>
                  <div className="hidden md:block overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-green-100">
                        <tr>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Application No
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Full Name
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Passport No / Nationality
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Miqaat / Rotation
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Visa Required
                          </th>
                          <th className="text-left p-3 text-xs text-gray-900">
                            Remarks
                          </th>
                          <th className="text-center p-3 text-xs text-gray-900">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {CompletedList.length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-center">
                              <NoApplicantFound />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {CompletedList &&
                              CompletedList?.map((applicant) => {
                                return (
                                  <tr
                                    key={applicant.visaApplicationId}
                                    className="border-b border-red-100 hover:bg-green-50/50"
                                  >
                                    <td className="p-3">
                                      <div>
                                        <span className="text-xs block text-green-700">
                                          {applicant.applicationNumber}
                                        </span>
                                        {/* {applicant.linkedTourNo && (
                                  <span className="text-[10px] text-gray-500 block mt-0.5">
                                    {applicant.linkedTourNo}
                                  </span>
                                )} */}
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.title} {applicant.firstName}{" "}
                                          {applicant.middleName}{" "}
                                          {applicant.lastName}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {/* {applicant.itsNo || applicant.loginId} */}
                                          {applicant.itsNo ?? "N/A"}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.passportNo || "-"}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {applicant.nationality}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <div>
                                        <p className="text-xs text-gray-900">
                                          {applicant.miqaatCode || "-"}
                                        </p>
                                        <p className="text-[10px] text-gray-500 mt-0.5">
                                          {applicant.rotationCode || "-"}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="p-3 text-center">
                                      <div className="flex flex-col items-center gap-0.5">
                                        <Badge
                                          className="text-[10px] flex items-center gap-0.5 w-fit px-1.5 py-0.5"
                                          style={{
                                            backgroundColor: applicant.visaRequired
                                              ? "#D1FAE5"
                                              : "#FEE2E2",
                                            color: applicant.visaRequired
                                              ? "#065F46"
                                              : "#991B1B",
                                          }}
                                        >
                                          {applicant.visaRequired ? "Yes" : "No"}
                                        </Badge>
                                        <span className="text-[10px] text-gray-600">
                                          ${applicant.visaFee || 0}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-3">
                                      <p className="text-xs text-red-600">
                                        {applicant.remarks || "No remark provided"}
                                      </p>
                                    </td>
                                    <td className="p-3">
                                      <div className="flex items-center justify-center">
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          className="h-8 w-8 p-0 hover:bg-green-50 text-green-600"
                                          onClick={() => handleViewDetails(applicant)}
                                          title="View & Update"
                                        >
                                          <Eye className="w-4 h-4" />
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View for Request More Info */}
                  <div className="md:hidden space-y-3 p-2">
                    {CompletedList.length === 0 && <NoApplicantFound />}
                    {CompletedList.length > 0 &&
                      CompletedList.map((applicant) => {
                        return (
                          <Card
                            key={applicant.visaApplicationId}
                            className="bg-white shadow-sm border-red-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
                          >
                            <CardContent className="p-3">
                              <div className="space-y-2">
                                {/* Application Number */}
                                <div>
                                  <p className="text-xs text-gray-500">
                                    Application No.
                                  </p>
                                  <p className="text-sm font-medium text-red-700">
                                    {applicant.applicationNumber}
                                  </p>
                                </div>
                                {/* Full Name and ITS */}
                                <div>
                                  <p className="text-xs text-gray-500">Full Name</p>
                                  <p className="text-sm text-gray-900">
                                    {applicant.title} {applicant.firstName}{" "}
                                    {applicant.middleName} {applicant.lastName}
                                  </p>
                                  <p className="text-[10px] text-gray-500 mt-0.5">
                                    {/* ITS: {applicant.itsNumber || applicant.loginId} */}
                                    ITS: {applicant.itsNo || "N/A"}
                                  </p>
                                </div>

                                {/* Passport and Nationality */}
                                <div className="grid grid-cols-2 gap-2">
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Passport No.
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.passportNo || "-"}
                                    </p>
                                  </div>
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Nationality
                                    </p>
                                    <p className="text-sm text-gray-900">
                                      {applicant.nationality}
                                    </p>
                                  </div>
                                </div>

                                {/* Visa Required and Cost */}
                                <div>
                                  <p className="text-xs text-gray-500 mb-1">
                                    Visa Required
                                  </p>
                                  <Badge
                                    className="text-[10px]"
                                    style={{
                                      backgroundColor: applicant.visaRequired
                                        ? "#D1FAE5"
                                        : "#FEE2E2",
                                      color: applicant.visaRequired
                                        ? "#065F46"
                                        : "#991B1B",
                                    }}
                                  >
                                    {applicant.visaRequired ? "Yes" : "No"}
                                  </Badge>
                                  <span className="text-[10px] text-gray-600 ml-2">
                                    ${applicant.visaFee || 0}
                                  </span>
                                </div>

                                {/* Remarks */}
                                <div>
                                  <p className="text-xs text-gray-500 mb-1">
                                    Remarks
                                  </p>
                                  <p className="text-xs text-red-600">
                                    {applicant.remarks || "No remark provided"}
                                  </p>
                                </div>

                                {/* Action Button */}
                                <div className="pt-2">
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className="w-full border-red-300 text-red-700 hover:bg-red-50"
                                    onClick={() => handleViewDetails(applicant)}
                                  >
                                    <Eye className="w-4 h-4 mr-2" />
                                    View & Update
                                  </Button>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        );
                      })}
                  </div>

                  {/* PAGINATION FOR REQUEST MORE INFO */}
                  <Pagination
                    totalItems={totalCompletedListCount}
                    itemsPerPage={filterFields.CompletedpageSize}
                    currentPage={filterFields.CompletedpageNo}
                    onPageChange={(page) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        CompletedpageNo: page, // convert back to 0-based
                      }))
                    }
                    onPageSizeChange={(size) =>
                      setFilterFields((prev) => ({
                        ...prev,
                        CompletedpageSize: size,
                        CompletedpageNo: 1,
                      }))
                    }
                    label="applicants"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      }
      {/* COMPLETED APPLICANTS SECTION END */}
      {/* ACCORDION ENDED */}


      {/* Delete Confirmation Dialog */}
      <ConfirmDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        title="Confirm Delete"
        description="Are you sure you want to delete this draft?"
        confirmText="Yes, Delete"
        // loading={isDeleting}
        onConfirm={confirmDeleteDraft}
        onCancel={cancelDeleteDraft} // ✅ NOW IT WORKS
      >
      </ConfirmDialog>
      {/* Delete Confirmation Dialog */}

      {/* Tour Type Selection Dialog */}
      <Dialog open={showTourTypeDialog} onOpenChange={setShowTourTypeDialog}>
        <DialogContent className="sm:max-w-[550px]">
          <DialogHeader>
            <DialogTitle
              className="flex items-center gap-2"
              style={{ color: "#5B9BD5" }}
            >
              <Users className="w-5 h-5" />
              Select Tour Type
            </DialogTitle>
            <DialogDescription className="text-gray-600">
              Please select the type of tour for which you want to add an
              applicant.
            </DialogDescription>
          </DialogHeader>

          <div className="py-2">
            <RadioGroup
              value={selectedTourOption}
              onValueChange={setSelectedTourOption}
            >
              <div className="max-h-[400px] overflow-y-auto space-y-4 bg-white p-2">
                {/* General Tour Option */}
                <div
                  onClick={() => setSelectedTourOption("general")}
                  className={`flex items-center p-3 border-2 rounded-lg cursor-pointer transition-all ${selectedTourOption === "general"
                    ? "border-green-500 bg-green-100"
                    : "border-gray-200 hover:border-[#5B9BD5] hover:bg-blue-50"
                    }`}
                >
                  <RadioGroupItem value="general" id="general" className="hidden" />
                  <div className="flex items-center gap-3 flex-1">
                    <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                      <Users className="w-4 h-4 text-[#5B9BD5]" />
                    </div>
                    <div className="flex-1">
                      <Label
                        htmlFor="general"
                        className="font-semibold text-gray-900 cursor-pointer"
                      >
                        General Tour
                      </Label>
                      <p className="text-sm text-gray-600">
                        Add applicant for general tours
                      </p>
                    </div>
                  </div>
                </div>
                {/* Individual Miqaat Tour Options */}
                {miqaatDetails.map((miqaat) => {
                  const isDisabled = miqaat.availableQuota === 0;
                  return (
                    <div
                      key={miqaat.rotationId}
                      onClick={() => {
                        if (!isDisabled) {
                          setSelectedTourOption(miqaat.rotationId);
                        }
                      }}
                      className={`flex items-start p-2 border-2 rounded-lg transition-all
                      ${isDisabled
                          ? "opacity-50 cursor-not-allowed bg-gray-100 border-gray-200"
                          : selectedTourOption === miqaat.rotationId
                            ? "border-green-500 bg-green-100 cursor-pointer"
                            : "border-gray-200 hover:border-[#5B9BD5] hover:bg-blue-50 cursor-pointer"
                        }`}
                    >
                      <RadioGroupItem
                        value={miqaat.rotationId}
                        id={miqaat.rotationId}
                        className="mt-1 hidden"
                        disabled={isDisabled}
                      />

                      <div className="flex-1 justify-between items-center">
                        <div className="flex items-center gap-3 mb-2">
                          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                            <EarthLock className="w-4 h-4 text-[#5B9BD5]" />
                          </div>

                          <div className="flex-1">
                            <div className="flex items-center gap-2 flex-wrap">
                              <Label
                                htmlFor={miqaat.rotationId}
                                className={`font-semibold ${isDisabled ? "text-gray-400" : "text-gray-900"
                                  } cursor-pointer`}
                              >
                                {miqaat.miqaatName} -
                                <Badge className="bg-green-700 text-white text-xs ml-1">
                                  {miqaat.rotationName}
                                </Badge>
                              </Label>
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm ml-10">
                          <div className="flex items-center gap-1 text-gray-600">
                            <Calendar className="w-3.5 h-3.5" />
                            <span>
                              Arrival Date:{" "}
                              <span className="font-semibold text-gray-900">
                                {miqaat.arrivalDate.split("T")[0]}
                              </span>
                            </span>
                          </div>

                          <div className="flex items-center gap-1 text-gray-600">
                            <Users className="w-3.5 h-3.5" />
                            <span>
                              Available Quota:{" "}
                              <span
                                className={`font-semibold ${isDisabled ? "text-red-500" : "text-gray-900"
                                  }`}
                              >
                                {miqaat.availableQuota}/{miqaat.totalQuota}
                              </span>
                            </span>
                            {/* {isDisabled ? (
                                <span className="text-red-500 text-xs font-medium">
                                  Quota not available (0/1000)
                                </span>
                              ) : (
                                <span>
                                  Available Quota:{" "}
                                  <span className="font-semibold text-gray-900">
                                    {miqaat.availableQuota}/1000
                                  </span>
                                </span>
                              )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </RadioGroup>
          </div>

          <DialogFooter className="gap-4 sm:gap-2">
            <Button
              variant="outline"
              onClick={() => {
                setShowTourTypeDialog(false);
                setSelectedTourOption("general");
              }}
              className="border-gray-300"
            >
              Cancel
            </Button>
            {canAdd && (
              <Button
                onClick={handleProceedWithTourSelection}
                className="text-white"
                style={{ backgroundColor: "#5B9BD5" }}
              >
                Proceed to Add Applicant
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
